(function ($) {

    var initSidePanel = function () {

        /**
         * Side Panel
         * @desc This event will apply button with class "js-side-panel-button" for control side panel by click
         * You can use attribute "data-side-panel" for specific button controll method
         * 
         * @example
         * <a class="js-side-panel-button" data-side-panel="show" href="#">Show Menu</a>
         */
        $('.js-side-panel-button').on('click', function () {
            var $body = $('body');
            var method = this.dataset.sidePanel || 'toggle';
            var methods = {
                show: function () {
                    $body.addClass('side-panel-show');
                },
                hide: function () {
                    $body.removeClass('side-panel-show');
                },
                toggle: function () {
                    if (this._state === 'show') {
                        this.hide();
                    } else {
                        this.show();
                    }
                },
                _state: $body.hasClass('side-panel-show') ? 'show' : 'hide'
            };
            methods[method]();
        });  
    };
    
    if (window.InitSidePanel === undefined) {
        window.InitSidePanel = initSidePanel;
    }
    window.InitSidePanel();
    
})(jQuery);